type BuildSessionStatusUrlArgs = {
  baseUrl: string
  sessionId: string
  includeDebug?: boolean
  conversationId?: string | null
}

export function buildSessionStatusUrl(args: BuildSessionStatusUrlArgs): string {
  const normalizedBaseUrl = args.baseUrl.replace(/\/$/, "")
  const encodedSessionId = encodeURIComponent(args.sessionId)
  const path = `/api/sessions/${encodedSessionId}/status`
  const params = new URLSearchParams()

  if (args.includeDebug) {
    params.set("debug", "1")
  }

  if (typeof args.conversationId === "string" && args.conversationId.trim().length > 0) {
    params.set("conversationId", args.conversationId.trim())
  }

  const query = params.toString()
  const suffix = query.length > 0 ? `?${query}` : ""

  return normalizedBaseUrl ? `${normalizedBaseUrl}${path}${suffix}` : `${path}${suffix}`
}
